module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/sp-title@2x-5587c6864fd415e60b46e3e21935752e.png";